
import { Loader2 } from 'lucide-react';
import { ApplicationCard } from './ApplicationCard';
import type { Application } from '@/types/database.types';

interface ApplicationListProps {
  applications: Application[];
  isLoading: boolean;
  onView: (applicationId: string) => void;
  onResetRequest: (applicationId: string) => void;
  onDeleteRequest: (applicationId: string) => void;
  onSubmit: (applicationId: string) => void;
  isActionInProgress: boolean;
}

export const ApplicationList = ({
  applications,
  isLoading,
  onView,
  onResetRequest,
  onDeleteRequest,
  onSubmit,
  isActionInProgress
}: ApplicationListProps) => {
  console.log('ApplicationList: Rendering with props:', {
    applicationsCount: applications?.length || 0,
    isLoading,
    isActionInProgress,
    sampleApplication: applications?.[0]
  });

  if (isLoading && (!applications || applications.length === 0)) {
    console.log('ApplicationList: Showing loading state');
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!applications || applications.length === 0) {
    console.log('ApplicationList: No applications found');
    return (
      <div className="space-y-4">
        <h1 className="text-xl font-bold sm:text-3xl">Applications</h1>
        <div className="text-center py-8">
          <p className="text-muted-foreground">No applications found</p>
        </div>
      </div>
    );
  }

  console.log('ApplicationList: Rendering', applications.length, 'applications');

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold sm:text-3xl">Applications</h1>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {applications.map((application, index) => {
          console.log(`ApplicationList: Rendering application ${index + 1}:`, application.id, application.company_legal_name);
          return (
            <ApplicationCard
              key={application.id}
              application={application}
              onView={onView}
              onResetRequest={onResetRequest}
              onDeleteRequest={onDeleteRequest}
              onSubmit={onSubmit}
              isActionInProgress={isActionInProgress}
            />
          );
        })}
      </div>
    </div>
  );
};
